import {
  slab, goal, sign, neon, checkpoint, edgeLights, bouncefloor,
} from '../kit.js';

/**
 * Intro sector: the kinetic floor. One short lesson, twice. Drop onto the
 * glowing floor and it hands your fall speed back as height; hold forward
 * and the bounce becomes the route. No portals required anywhere.
 */
export default {
  id: 'rebound',
  name: 'REBOUND',
  blurb: 'The floor gives it back. Hold forward.',
  mode: { type: 'sprint', par: 22 },
  redline: { seconds: 17 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 20.4, 4], yaw: 0 },
  killY: -70,
  env: {
    fog: 0x0c1a06,
    fogDensity: 0.0044,
    sky: { zenith: 0x050d02, horizon: 0x1c2e0a, glow: 0x6ab018, aurora: 0x9dff3c },
    floorY: -200,
  },
  objects: [
    // ---- start ledge, high
    slab(0, 20, 0, 20, 20, 'plate', 1.4),
    ...edgeLights(0, 20, 0, 20, 20, 'lime'),
    checkpoint(0, 20, 4),
    sign(0, 23.2, 3, 0, ['REBOUND', 'THE KINETIC FLOOR RETURNS YOUR FALL', 'WALK OFF. HOLD FORWARD.'], '#9dff3c'),

    // ---- lesson one: fall 20, bounce to ~17, drift onto the ledge. The
    // ledge is LOW (y12) and deep so the bounce arc lands ON it rather than
    // kissing its front face; drift while airborne is basically walk speed
    // (air steer only tops up below its cap), so distances stay short.
    bouncefloor(0, 0, -24, 16, 18),
    slab(0, 12, -42, 18, 20, 'plate', 1.4),
    ...edgeLights(0, 12, -42, 18, 20, 'lime'),
    checkpoint(0, 12, -40),
    sign(0, 15.2, -39, 0, ['AGAIN, BUT BIGGER', 'THE BOUNCE CARRIES YOU'], '#ffb020'),

    // ---- lesson two: fall 32, bounce to ~29, sail toward the goal. A
    // second floor waits under the deck lip to forgive a short flight.
    bouncefloor(0, -20, -68, 14, 16),
    neon(0, -19.2, -68, [12, 0.14, 0.14], 'lime'),
    bouncefloor(0, -24, -88, 12, 12),

    // ---- goal deck
    slab(0, -2, -98, 26, 26, 'plate', 1.6),
    ...edgeLights(0, -2, -98, 26, 26, 'cyan'),
    checkpoint(0, -2, -92),
    goal(0, -2, -104, 0),
  ],
};
